export const DISCOUNT_COMPUTER = 'discount computer';
export const PORTABLE_SINGULARITY = 'portable singularity';

export const personalEquipments = [
  DISCOUNT_COMPUTER,
  PORTABLE_SINGULARITY,
] as const;

export type PersonalEquipment = typeof personalEquipments[number];
